import { makeFetchUserToken } from '@rodeo-dev/team-chat'
import React, { useEffect, useState } from 'react'
import { StreamChat } from 'stream-chat'
import app from '../../app'
import { TeamChatContext } from './team-chat-context'
import { isChatEnabled } from '../../common/page/page_chat/utils'

const UPDATE_EVENTS = ['notification.message_new', 'notification.mark_read', 'message.new']

const TeamChatContextProvider = ({ children }) => {
  const [totalUnreadCount, setTotalUnreadCount] = useState()
  const [chatClient, setChatClient] = useState()
  const chatEnabled = isChatEnabled()

  useEffect(() => {
    if (chatEnabled) {
      (async () => {
        try {
          const webappJWTToken = window.localStorage.getItem(app.getJwtStorageKey())
          if (!webappJWTToken) return

          const { APIKey, baseURL, streamBaseURL } = app.getConfig().chat
          const userToken = await makeFetchUserToken(baseURL, `Bearer ${webappJWTToken}`)(app.user.id)

          const client = StreamChat.getInstance(APIKey)
          client.setBaseURL(streamBaseURL)
          setChatClient(client)

          const user = await client.connectUser({ id: app.user.id }, userToken)
          setTotalUnreadCount(user.me.total_unread_count || 0)

          const handleEvents = (event) => {
            if (!UPDATE_EVENTS.includes(event.type)) return
            setTotalUnreadCount(event.total_unread_count || 0)
          }
          client.on(handleEvents)
        } catch (err) {
          console.log(err)
        }
      })()
    }
  }, [])

  const value = { chatClient, totalUnreadCount, setTotalUnreadCount }

  return (
    <TeamChatContext.Provider value={value}>
      {children}
    </TeamChatContext.Provider>
  )
}

export { TeamChatContextProvider }
